import { Injectable } from '@angular/core';
import { ReqService } from './req.service';
import { SearchStateService } from './search-state.service';
import { AnalyticsService } from './analytics.service';

let locale: any;
let language: string;
let section: any;

@Injectable()
export class MapService {
  constructor(
    private reqService: ReqService,
    private searchStateService: SearchStateService,
    private analyticsService: AnalyticsService,
  ) {
    locale = this.reqService.getLocale();
    language = [...locale][0] + [...locale][1];
    section = this.searchStateService.getSection();
  }

  public initAvuxi(showBy: 'click' | 'show', type) {
    setTimeout(() => this.avuxi(type), 0);
    this.trackAvuxiEvent(showBy);
  }

  private trackAvuxiEvent(showBy: 'click' | 'show') {
    const [first, ...rest] = [...section];
    section = first.toUpperCase() + rest.join('');
    this.analyticsService.trackEvent({
      action: 'Show Avuxi - Location Score',
      section: section,
      label: showBy,
    });
  }

  private avuxi(type) {
    if (type === 'map') {
      // @ts-ignore
      return new AvuxiLocationPagesTravelWidget('vxapp_map');
    } else {
      // @ts-ignore
      return new AvuxiLocationScoresTravelStandardWidget('vxapp_location');
    }
  }
}
